export const EVENT_DETAILS_CONTEXT = {
  EVENT: 'EVENT',
  SLIDESHOW: 'SLIDESHOW',
};
